// export const APP_MODE = import.meta.env.MODE; // ["production","development"]
export const ProjectUrl = "https://alp-be.hkstest.uk/";
// export const ProjectUrl = "http://localhost:8000/";
// export const ProjectUrl = "https://prod.alpshop.in/";
// export const ProjectUrl = "https://api-staging.alpshop.in/";
// export const ProjectUrl = "https://alp-be-demo.hkstest.uk/";
// export const ProjectUrl = "https://alp-be-staged.hkstest.uk/";
// export const ProjectUrl = "https://api.alpshop.in/";
// export const ProjectUrl = "https://api2.alpshop.in/";
